/**************************************************
 * Nombre:       Tarjeta_ProcentajeTitulo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";

const Tarjeta_ProcentajeTitulo = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography sx={{fontSize: 42, fontWeight: 700}}>{item.porcentaje + ' %'}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: -1}}>
                <Typography sx={{fontSize: 18}}>{item.nombre}</Typography>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_ProcentajeTitulo